import { FormGroup } from "@angular/forms";
import { SeguridadService } from '../../services/seguridad.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Global } from '../../../global';


export class Ventana {
    
    private _seguridad = new SeguridadService();
    private _typeRegister: string = Global.MAESTRO;
    private _prefixPage: string = 'pages';
    private _objSession = {severity: 'error', summary: 'Sesión Expirada', detail: 'Lo vamos a redirigir para volver a ingresar'};
    private _routerLogout = ['auth','logout'];
    private _objeto: any;
    private _loading: boolean = false;
    private _formGroup: FormGroup;
    private _objClass: any;
    
    private _objClassOnLista: any;
    private _serviceOnLista: any;
    private _tituloOnLista: string;
    private _columnasOnLista: Record<string, any>[] = [];
    private _filters: Record<string, any>[] = [];
    private _showOnLista: boolean = false;
    private _recordNameOnLista: string;

    private _modulo: string;
    private _codigoRegistro: string;
    private _navigate: string[] = [];
    private _readonly = true;
    
    private _cargando: boolean = false;

    constructor( public router: Router, public activateRoute: ActivatedRoute, public messageService: MessageService, public service: any ) {}

    get currentUser() {
        return this._seguridad.getCurrentUser();
    }

    set typeRegister( typeRegister: string ) {
        this._typeRegister = typeRegister;
    }
    get typeRegister() {
        return this._typeRegister;
    }

    get prefixPage() {
        return this._prefixPage;
    }
    get objSession() {
        return this._objSession;
    }
    get routerLogout() {
        return this._routerLogout;
    }

    set loading( loading: boolean ) {
        this._loading = loading;
    }
    get loading(): boolean {
        return this._loading;
    }

    set objeto( objeto: any ) {
        this._objeto = objeto;
    }
    get objeto(): any {
        return this._objeto;
    }

    set objClass( objClass: any ) {
        this._objClass = objClass;
    }
    get objClass(): any {
        return this._objClass;
    }

    set navigate( navigate: string[] ) {
        this._navigate = navigate;
    }
    get navigate(): string[] {
        return this._navigate;
    }

    set serviceOnLista( serviceOnLista: any ) {
        this._serviceOnLista = serviceOnLista;
    }
    get serviceOnLista() {
        return this._serviceOnLista;
    }

    set tituloOnLista( tituloOnLista: string ) {
        this._tituloOnLista = tituloOnLista;
    }
    get tituloOnLista() {
        return this._tituloOnLista;
    }

    set columnasOnLista( columnasOnLista: Record<string, any>[] ) {
        this._columnasOnLista = columnasOnLista;
    }
    get columnasOnLista(): Record<string, any>[] {
        return this._columnasOnLista;
    }

    set objClassOnLista( objClassOnLista: any ) {
        this._objClassOnLista = objClassOnLista;
    }
    get objClassOnLista() {
        return this._objClassOnLista;
    }

    set showOnLista( showOnLista: boolean ) {
        this._showOnLista = showOnLista;
    }
    get showOnLista(): boolean {
        return this._showOnLista;
    }

    set filters( filters: Record<string, any>[] ) { this._filters = filters };
    get filters(): Record<string, any>[] { return this._filters };

    set recordNameOnLista( recordNameOnLista: string ) {
        this._recordNameOnLista = `${ Global.PREFIX_RECORD }.${ recordNameOnLista }`;
    }
    get recordNameOnLista(): string {
        return this._recordNameOnLista;
    }

    set formGroup( formGroup: FormGroup ) {
        this._formGroup = formGroup;
    }
    get formGroup() {
        return this._formGroup;
    }

    set modulo( modulo: string ) {
        this._modulo = modulo;
    }
    get modulo() {
        return this._modulo;
    }

    set codigoRegistro( codigoRegistro: string ) {
        this._codigoRegistro = codigoRegistro;
    }
    get codigoRegistro() {
        return this._codigoRegistro;
    }

    set cargando( cargando: boolean ) {
        this._cargando = cargando;
    }
    get cargando(): boolean {
        return this._cargando;
    }

    async initComponent() {
        this.loading = true;
        const id = this.activateRoute.snapshot.paramMap.get('id');
        this.objeto = new this._objClass();
        if ( id !== 'nuevo' ) {
            const resp = await this.service.get(+id);
            if ( resp.ok ) {
                await this.objeto.cargarObjeto(resp.resp);
            }
        }
        this._formGroup = await this.objeto.getFormGroup();
        this.loading = false;
    }

    invalidControl( name: string ) {
        return this._formGroup.get(name).invalid && this._formGroup.get(name).touched;
    }

    invalidControlDetalle( fg: FormGroup, name: string ) {
        return fg.get(name).invalid && fg.get(name).touched;
    }

    async setInvalidControlsDetalle( fg: FormGroup ) {
        Object.keys(fg.controls).forEach( key => {
            fg.controls[key].markAsDirty();
            fg.controls[key].markAsTouched();
        });
    }

    isReadonly() {
        return ( this._formGroup?.value.id && this._readonly );
    }

    esNuevo() {
        if ( this._formGroup?.value.id ) {
            return false;
        }
        return true;
    }

    async volver() {
        this.router.navigate(this._navigate);
    }

    async nuevo() {
        await this.router.navigate([...this._navigate, 'nuevo']);
        await this.initComponent();
    }

    async check(): Promise<boolean> {
        return true;
    }

    async guardar() {
        if ( this._formGroup.invalid ) {
            await this.setInvalidControls();
            this.messageService.add({severity: 'error', summary: 'Formulario Inválido', detail: 'Complete los campos obligatorios'})
            return;
        }
        if ( !await this.check() ) { return };
        this.cargando = true;
        await this.actualizarAuditoria();
        await this._objeto.actualizarDatos(this._formGroup.value);
        this._objeto.serverJson = this._formGroup.value;
        let resp = null;
        if ( this._objeto.id ) {
            resp = await this._objeto.actualizar(this.service);
        } else {
            resp = await this._objeto.guardar(this.service);
        }
        this.cargando = false;
        if ( resp.ok ) {
            this.messageService.add( {severity: 'success', summary: 'Registro Guardado', detail: 'Se guardo correctamente'} );
            setTimeout( () => { this.volver() }, 1000);
        } else {
            this.messageService.add( {severity: 'error', summary: resp.msg, detail: resp.resp} );
        }
    }

    async eliminar() {
        if ( this._typeRegister === Global.TRANSACCION ) {
            if ( this._formGroup.value.aprobado === true ) {
                this.messageService.add( {severity: 'error', summary: 'Estado Inválido', detail: 'No se puede eliminar una transacción aprobado'} );
                return;
            }
        } else {
            if ( this._formGroup.value.activo === false ) {
                this.messageService.add( {severity: 'error', summary: 'Estado Inválido', detail: 'No se puede eliminar un registro inactivado'} );
                return;
            }
        }
        this.cargando = true;
        await this.actualizarAuditoria();
        this._objeto.serverJson = this._formGroup.value;
        const resp = await this._objeto.eliminar(this.service);
        this.cargando = false
        if ( resp.ok ) {
            this.messageService.add( {severity: 'success', summary: 'Registro Eliminado', detail: 'Se eliminó correctamente'} );
            setTimeout( () => { this.volver() }, 1000);
        } else {
            this.messageService.add( {severity: 'error', summary: resp.msg, detail: resp.resp} );
        }
    }

    async inactivar( revert: boolean = false ) {
        this.cargando = true;
        this._formGroup.get('activo').setValue(revert);
        await this.actualizarAuditoria();
        await this._objeto.actualizarDatos(this._formGroup.value);
        this._objeto.serverJson = this._formGroup.value;
        const resp = await this._objeto.actualizar(this.service);
        this.cargando = false;
        if ( resp.ok ) {
            this.messageService.add( {severity: 'success', summary: 'Registro Inactivado', detail: 'Se inactivo correctamente'} );
            setTimeout( () => { this.volver() }, 1000);
        } else {
            this.messageService.add( {severity: 'error', summary: resp.msg, detail: resp.resp} );
        }
    }

    async anular( revert: boolean = false ) {
        if ( this._formGroup.get('aprobado').value === true ) {
            this.cargando = true;
            this._formGroup.get('anulado').setValue(!revert);
            await this.actualizarAuditoria();
            await this._objeto.actualizarDatos(this._formGroup.value);
            this._objeto.serverJson = this._formGroup.value;
            const resp = await this._objeto.actualizar(this.service);
            this.cargando = false;
            if ( resp.ok ) {
                if (revert) {
                    this.messageService.add( {severity: 'success', summary: 'Transacción ', detail: 'Se revertió correctamente'} );
                } else {
                    this.messageService.add( {severity: 'success', summary: 'Transacción Anulada', detail: 'Se anuló correctamente'} );
                }
                setTimeout( () => { this.volver() }, 1000);
            } else {
                this.messageService.add( {severity: 'error', summary: resp.msg, detail: resp.resp} );
            }
        } else {
            this.messageService.add( {severity: 'error', summary: 'Estado Inválido', detail: 'La transacción debe estar aprobada para anular'} );
        }
    }

    async aprobar( revert: boolean = false ) {
        if ( this._formGroup.get('anulado').value === false ) {
            this.cargando = true;
            this._formGroup.get('aprobado').setValue(!revert);
            await this.actualizarAuditoria();
            await this._objeto.actualizarDatos(this._formGroup.value);
            this._objeto.serverJson = this._formGroup.value;
            const resp = await this._objeto.actualizar(this.service);
            this.cargando = false;
            if ( resp.ok ) {
                if (revert) {
                    this.messageService.add( {severity: 'success', summary: 'Transacción Desaprobada', detail: 'Se revertió correctamente'} );
                } else {
                    this.messageService.add( {severity: 'success', summary: 'Transacción Aprobada', detail: 'Se aprobó correctamente'} );
                }
                await this.initComponent()
                return true;
                // setTimeout( () => { this.volver() }, 1000);
            } else {
                this.messageService.add( {severity: 'error', summary: resp.msg, detail: resp.resp} );
                return false;
            }
        } else {
            this.messageService.add( {severity: 'error', summary: 'Estado Inválido', detail: 'La transacción está anulada'} );
            return false;
        }
    }

    async setInvalidControls() {
        Object.keys(this._formGroup.controls).forEach( key => {
            this._formGroup.controls[key].markAsDirty();
            this._formGroup.controls[key].markAsTouched();
        });
    }

    async editar() {
        if ( this._typeRegister === Global.TRANSACCION ) {
            if ( this._formGroup.value.anulado === true ) {
                this.messageService.add( {severity: 'error', summary: 'Estado Inválido', detail: 'No se puede editar una transacción anulada'} );
                return;
            }
            if ( this._formGroup.value.aprobado === true ) {
                this.messageService.add( {severity: 'error', summary: 'Estado Inválido', detail: 'No se puede editar una transacción aprobada'} );
                return;
            }
        } else {
            if ( this._formGroup.value.activo === false ) {
                this.messageService.add( {severity: 'error', summary: 'Estado Inválido', detail: 'No se puede editar un registro inactivado'} );
                return;
            }
        }
        this._readonly = false;
    }

    async actualizarAuditoria() {
        const currentUser = this._seguridad.getCurrentUser();

        if ( this._formGroup.value.id ) {
            
            if ( this._formGroup.value?.activo === false ) {
                this._formGroup.get('id_inactivado_por').setValue(currentUser.id);
            }

            if ( this._formGroup.value?.anulado === true ) {
                this._formGroup.get('id_anulado_por').setValue(currentUser.id);
            }

            this._formGroup.get('id_actualizado_por').setValue(currentUser.id);
        }

    }

    async onLista( service: any, clase: any, title: string, filters: Record<string, any>[] = [] ) {
        this._serviceOnLista = service;
        this._objClassOnLista = clase;
        this._tituloOnLista = title;
        this._columnasOnLista = clase.columsOnLista;
        this.recordNameOnLista = clase.RECORD_NAME;
        this._showOnLista = true;
        this._filters = filters;
    }

    async cerrarOnLista( obj?: Record<string, any> ) {
        this._serviceOnLista = null;
        this._columnasOnLista = [];
        this._tituloOnLista = '';
        this._showOnLista = false;
        this._filters = [];
    }

    async imprimir() {
        alert("Implementar")
    }

    async getFiltroEmpresa() {
        let filtros = [];
        if ( this.formGroup.value?.id_empresa ) {
            filtros.push({ field: 'id_empresa', value: this.formGroup.value.id_empresa, type: 'id' })
        }
        return filtros;
    }

}